import { useEffect, useState } from "react";
import logout from "@/utils/logout";
import { useAssessmentData, useAuthStore } from "@/context/store";
import { useRouter } from "next/router";

const DEFAULT_OVERLAY_STATE = {
  show: false,
  LoginRedirectPath: "",
};

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return {};
  }
};

const usePartnerOverlay = ({
  isPartnerContent,
  partnerRedirectPath = "/academy/login?role=partner",
} = {}) => {
  const router = useRouter();
  const { clearAssessmentResult } = useAssessmentData();
  const { setPreviousPath } = useAuthStore();

  const [overlayState, setOverlayState] = useState(DEFAULT_OVERLAY_STATE);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (!isPartnerContent) {
      setOverlayState(DEFAULT_OVERLAY_STATE);
      return;
    }

    const storedValue = window.localStorage.getItem("user");
    const user = storedValue ? safeParse(storedValue) : {};

    const notLoggedIn =
      !storedValue ||
      !user ||
      typeof user !== "object" ||
      Object.keys(user).length === 0 ||
      !user.email;

    if (notLoggedIn) {
      setOverlayState({
        show: true,
        LoginRedirectPath: partnerRedirectPath,
      });
      return;
    }

    const userTags = Array.isArray(user.tags) ? user.tags : [];

    if (!userTags.includes("channeltivity")) {
      setOverlayState({
        show: true,
        LoginRedirectPath: partnerRedirectPath,
      });
      return;
    }

    setOverlayState(DEFAULT_OVERLAY_STATE);
  }, [isPartnerContent, partnerRedirectPath]);

  const handleLogout = () => {
    if (typeof window === "undefined") return;

    const storedValue = window.localStorage.getItem("user");
    const user = storedValue ? safeParse(storedValue) : {};

    const notLoggedIn =
      !storedValue ||
      !user ||
      typeof user !== "object" ||
      Object.keys(user).length === 0 ||
      !user.email;

    if (notLoggedIn) return;

    logout();
    clearAssessmentResult();
    setPreviousPath(`/academy${router.asPath}`);
  };

  return { overlayState, handleLogout };
};

export default usePartnerOverlay;
